/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { TrackCreate } from '../models';
// @ts-ignore
import type { TrackResponse } from '../models';
/**
 * ArtrackTracksApi - axios parameter creator
 */
export const ArtrackTracksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new track
         * @summary Create Track
         * @param {TrackCreate} trackCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrackArtrackTracksPost: async (trackCreate: TrackCreate, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackCreate' is not null or undefined
            assertParamExists('createTrackArtrackTracksPost', 'trackCreate', trackCreate)
            const localVarPath = `/artrack/tracks/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a track
         * @summary Delete Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrackArtrackTracksTrackIdDelete: async (trackId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('deleteTrackArtrackTracksTrackIdDelete', 'trackId', trackId)
            const localVarPath = `/artrack/tracks/{track_id}`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get track details
         * @summary Get Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackArtrackTracksTrackIdGet: async (trackId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('getTrackArtrackTracksTrackIdGet', 'trackId', trackId)
            const localVarPath = `/artrack/tracks/{track_id}`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List tracks
         * @summary List Tracks
         * @param {string} [visibility] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTracksArtrackTracksGet: async (visibility?: string, limit?: number, offset?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/tracks/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (visibility !== undefined) {
                localVarQueryParameter['visibility'] = visibility;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a track
         * @summary Update Track
         * @param {number} trackId 
         * @param {TrackCreate} trackCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrackArtrackTracksTrackIdPut: async (trackId: number, trackCreate: TrackCreate, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('updateTrackArtrackTracksTrackIdPut', 'trackId', trackId)
            // verify required parameter 'trackCreate' is not null or undefined
            assertParamExists('updateTrackArtrackTracksTrackIdPut', 'trackCreate', trackCreate)
            const localVarPath = `/artrack/tracks/{track_id}`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtrackTracksApi - functional programming interface
 */
export const ArtrackTracksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtrackTracksApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new track
         * @summary Create Track
         * @param {TrackCreate} trackCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrackArtrackTracksPost(trackCreate: TrackCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrackArtrackTracksPost(trackCreate, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackTracksApi.createTrackArtrackTracksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a track
         * @summary Delete Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrackArtrackTracksTrackIdDelete(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrackArtrackTracksTrackIdDelete(trackId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackTracksApi.deleteTrackArtrackTracksTrackIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get track details
         * @summary Get Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackArtrackTracksTrackIdGet(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackArtrackTracksTrackIdGet(trackId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackTracksApi.getTrackArtrackTracksTrackIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List tracks
         * @summary List Tracks
         * @param {string} [visibility] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTracksArtrackTracksGet(visibility?: string, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrackResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTracksArtrackTracksGet(visibility, limit, offset, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackTracksApi.listTracksArtrackTracksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a track
         * @summary Update Track
         * @param {number} trackId 
         * @param {TrackCreate} trackCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrackArtrackTracksTrackIdPut(trackId: number, trackCreate: TrackCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrackArtrackTracksTrackIdPut(trackId, trackCreate, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackTracksApi.updateTrackArtrackTracksTrackIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArtrackTracksApi - factory interface
 */
export const ArtrackTracksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtrackTracksApiFp(configuration)
    return {
        /**
         * Create a new track
         * @summary Create Track
         * @param {TrackCreate} trackCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrackArtrackTracksPost(trackCreate: TrackCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<TrackResponse> {
            return localVarFp.createTrackArtrackTracksPost(trackCreate, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a track
         * @summary Delete Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrackArtrackTracksTrackIdDelete(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteTrackArtrackTracksTrackIdDelete(trackId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get track details
         * @summary Get Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackArtrackTracksTrackIdGet(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<TrackResponse> {
            return localVarFp.getTrackArtrackTracksTrackIdGet(trackId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * List tracks
         * @summary List Tracks
         * @param {string} [visibility] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTracksArtrackTracksGet(visibility?: string, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TrackResponse>> {
            return localVarFp.listTracksArtrackTracksGet(visibility, limit, offset, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a track
         * @summary Update Track
         * @param {number} trackId 
         * @param {TrackCreate} trackCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrackArtrackTracksTrackIdPut(trackId: number, trackCreate: TrackCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateTrackArtrackTracksTrackIdPut(trackId, trackCreate, xAPIKEY, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArtrackTracksApi - interface
 */
export interface ArtrackTracksApiInterface {
    /**
     * Create a new track
     * @summary Create Track
     * @param {TrackCreate} trackCreate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTrackArtrackTracksPost(trackCreate: TrackCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<TrackResponse>;

    /**
     * Delete a track
     * @summary Delete Track
     * @param {number} trackId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTrackArtrackTracksTrackIdDelete(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Get track details
     * @summary Get Track
     * @param {number} trackId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTrackArtrackTracksTrackIdGet(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<TrackResponse>;

    /**
     * List tracks
     * @summary List Tracks
     * @param {string} [visibility] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTracksArtrackTracksGet(visibility?: string, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TrackResponse>>;

    /**
     * Update a track
     * @summary Update Track
     * @param {number} trackId 
     * @param {TrackCreate} trackCreate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTrackArtrackTracksTrackIdPut(trackId: number, trackCreate: TrackCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

}

/**
 * ArtrackTracksApi - object-oriented interface
 */
export class ArtrackTracksApi extends BaseAPI implements ArtrackTracksApiInterface {
    /**
     * Create a new track
     * @summary Create Track
     * @param {TrackCreate} trackCreate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTrackArtrackTracksPost(trackCreate: TrackCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackTracksApiFp(this.configuration).createTrackArtrackTracksPost(trackCreate, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a track
     * @summary Delete Track
     * @param {number} trackId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTrackArtrackTracksTrackIdDelete(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackTracksApiFp(this.configuration).deleteTrackArtrackTracksTrackIdDelete(trackId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get track details
     * @summary Get Track
     * @param {number} trackId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTrackArtrackTracksTrackIdGet(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackTracksApiFp(this.configuration).getTrackArtrackTracksTrackIdGet(trackId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List tracks
     * @summary List Tracks
     * @param {string} [visibility] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listTracksArtrackTracksGet(visibility?: string, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackTracksApiFp(this.configuration).listTracksArtrackTracksGet(visibility, limit, offset, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a track
     * @summary Update Track
     * @param {number} trackId 
     * @param {TrackCreate} trackCreate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTrackArtrackTracksTrackIdPut(trackId: number, trackCreate: TrackCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackTracksApiFp(this.configuration).updateTrackArtrackTracksTrackIdPut(trackId, trackCreate, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }
}

